import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { registerField } from 'core/forms';
import { Typo } from 'uikit/content';
import { TextInput } from 'uikit/inputs';

import styles from '../styles/formFieldSubdomain.module.scss';

const defaultSchema = {
  className: '',
  domain: 'exceedlms.com',
  isDisabled: false,
  maxLength: null,
  placeholder: '',
};

const FormFieldSubdomain = ({ fieldId, updateField, value = '', schema: propsSchema = {} }) => {
  const schema = { ...defaultSchema, ...propsSchema };
  const { className, domain, isDisabled, maxLength, placeholder } = schema;

  return (
    <div className={classNames(styles.element, className)}>
      <Typo className={styles.urlText} variant="s03">
        https://
      </Typo>
      <TextInput
        id={fieldId}
        isDisabled={isDisabled}
        maxLength={maxLength}
        onChange={updateField}
        placeholder={placeholder}
        value={value === null ? '' : value}
      />
      <Typo className={styles.urlText} variant="s03">
        .{domain}
      </Typo>
    </div>
  );
};

FormFieldSubdomain.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    className: PropTypes.string,
    domain: PropTypes.string,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.number,
    placeholder: PropTypes.string,
  }),
};

registerField('Subdomain', memo(FormFieldSubdomain));

export default FormFieldSubdomain;
